import TestItemExtraFields from "./TestItemExtraFields";
import ChallengeItemExtraFields from "./ChallengeItemExtraFields";
import LessonItemExtraFields from "./LessonItemExtraFields";
import SectionLinkItemExtraFields from "./SectionLinkItemExtraFields";
import LinkItemExtraFields from "./LinkItemExtraFields";
import MemorizationItemExtraFields from "./MemorizationItemExtraFields";
import { scheduleItemTypes } from "../../actprep-ui/constants/program";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";
import HelpOutline from "@mui/icons-material/HelpOutline";
import Link from "@mui/icons-material/Link";
import Psychology from "@mui/icons-material/Psychology";
import School from "@mui/icons-material/School";
import TaskAlt from "@mui/icons-material/TaskAlt";

const scheduleItemTypeOptions = {
  [scheduleItemTypes.BASIC]: {
    item_type: scheduleItemTypes.BASIC,
    icon: TaskAlt,
    title: "Basic",
    description: "Show basic information to the student",
    ExtraFields: null,
    defaultMetadata: {},
  },
  [scheduleItemTypes.TEST]: {
    item_type: scheduleItemTypes.TEST,
    icon: AssignmentTurnedIn,
    title: "Test",
    description: "Have the student take a test",
    ExtraFields: TestItemExtraFields,
    defaultMetadata: {
      test: null,
      take_test_in_challenges: false,
      automatically_select_test: true,
      subject: "",
    },
  },
  [scheduleItemTypes.CHALLENGE]: {
    item_type: scheduleItemTypes.CHALLENGE,
    icon: HelpOutline,
    title: "Challenge",
    description: "Have the student take a challenge",
    ExtraFields: ChallengeItemExtraFields,
    defaultMetadata: {
      challenge: null,
      automatically_select_challenge: true,
    },
  },
  [scheduleItemTypes.LESSON]: {
    item_type: scheduleItemTypes.LESSON,
    icon: School,
    title: "Lesson",
    description: "Have the student complete a lesson",
    ExtraFields: LessonItemExtraFields,
    defaultMetadata: {
      lesson: null,
    },
  },
  [scheduleItemTypes.SECTION_LINK]: {
    item_type: scheduleItemTypes.SECTION_LINK,
    icon: TaskAlt,
    title: "Section Link",
    description: "Take the student to a different part of the app",
    ExtraFields: SectionLinkItemExtraFields,
    defaultMetadata: {
      section: "",
    },
  },
  [scheduleItemTypes.LINK]: {
    item_type: scheduleItemTypes.LINK,
    title: "Link",
    icon: Link,
    description: "Link the student to a different page/website.",
    ExtraFields: LinkItemExtraFields,
    defaultMetadata: {
      url: "",
    },
  },
  [scheduleItemTypes.MEMORIZATION]: {
    item_type: scheduleItemTypes.MEMORIZATION,
    icon: Psychology,
    title: "Memorization",
    description: "Have the student practice memorization.",
    ExtraFields: MemorizationItemExtraFields,
    defaultMetadata: {
      memorization_type: "current_week",
    },
  },
};
export default scheduleItemTypeOptions;
